<template>
  <div class="c-income">
    <!-- <Loading :loading="loading"> -->
    <div class="content">
      <van-nav-bar title="预估收入" left-arrow @click-left="onClickLeft" />
    </div>
    <div class="card">
      <div class="title">
        <div class="date">2021年9月</div>
        <van-icon name="arrow" size="18px" />
      </div>
      <div class="line"></div>
      <div class="income">
        <div class="container">
          <div class="baodan">新增保单(件)</div>
          <div class="money">0.00</div>
        </div>
        <div>
          <div class="baodan">新增保费(元)</div>
          <div class="money">0.00</div>
        </div>
        <div>
          <div class="baodan">预估收入(元)</div>
          <div class="money">0.00</div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="title">
        <div class="date">2021年9月</div>
        <van-icon name="arrow" size="18px" />
      </div>
      <div class="line"></div>
      <div class="income">
        <div class="container">
          <div class="baodan">新增保单(件)</div>
          <div class="money">0.00</div>
        </div>
        <div>
          <div class="baodan">新增保费(元)</div>
          <div class="money">0.00</div>
        </div>
        <div>
          <div class="baodan">预估收入(元)</div>
          <div class="money">0.00</div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="title">
        <div class="date">2021年9月</div>
        <van-icon name="arrow" size="18px" />
      </div>
      <div class="line"></div>
      <div class="income">
        <div class="container">
          <div class="baodan">新增保单(件)</div>
          <div class="money">0.00</div>
        </div>
        <div>
          <div class="baodan">新增保费(元)</div>
          <div class="money">0.00</div>
        </div>
        <div>
          <div class="baodan">预估收入(元)</div>
          <div class="money">0.00</div>
        </div>
      </div>
      <div class=""></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  methods: {
    onClickLeft() {
      window.history.go(-1)
    }
  }
}
</script>
<style scoped lang="less">
.c-income {
  background: #fafafa;
  height: 100%;
  .card {
    width: 345px;
    margin: 15px 15px 0 15px;
    background-color: #fff;
    box-shadow: #eaeaea 0 0 10px 0;
    border-radius: 4px;
    .title {
      display: flex;
      justify-content: space-between;
      padding: 15px;
      .date {
        font-size: 18px;
        font-weight: bold;
      }
    }
    .line {
      width: 345px;
      height: 0.5px;
      background-color: #f3f3f3;
    }
    .income {
      display: flex;
      justify-content: space-between;
      padding: 15px;
      .baodan {
        font-size: 15px;
        color: #999;
      }
      .money {
        font-size: 18px;
        color: #333;
        font-weight: bold;
      }
    }
  }
}
</style>